import { getVisibleOffers } from './filters-selector';

const getOffers = state => state.purchases.list;
export const getVisiblePurchases = getVisibleOffers(getOffers);
